import React from 'react'

function Team() {
  return (
    <div className="flex flex-col h-screen ">
      <div className=" font-productsans text-xl mt-10 flex items-center justify-center">
        Without bonding and coordination, every project is a failure. Look at
        who makes KICKSUP great. ;&#41;
      </div>
      <div class="flex items-center justify-center mt-14 mb-5  gap-4">
        <div class="flex flex-col items-center justify-center bg-white p-4 shadow-2xl shadow-black rounded-lg">
          <div class="inline-flex shadow-lg border border-gray-200 rounded-full overflow-hidden h-40 w-40">
            <img src="./assets/zidane.jpg" alt="" class="h-full w-full" />
          </div>

          <h2 class="mt-4 font-bold text-xl">Zidane</h2>
          <h6 class="mt-2 text-sm font-medium">Leadership and Management</h6>
          <ul class="flex flex-row mt-4 space-x-2">
            <li>
              <div
                href=""
                class="flex items-center   justify-center h-8 w-8  text-gray-800 border-gray-800"
              >
                <img
                  classname="rounded-full w-8 h-8 "
                  src="../assets/facebook.png"
                  alt="instagram"
                />
              </div>
            </li>
            <li>
              <div
                href=""
                class="flex items-center   justify-center h-8 w-8  text-gray-800 border-gray-800"
              >
                <img
                  classname="rounded-full w-8 h-8 "
                  src="../assets/twitter.png"
                  alt="instagram"
                />
              </div>
            </li>
            <li>
              <div
                href=""
                class="flex items-center   justify-center h-8 w-8  text-gray-800 border-gray-800"
              >
                <img
                  classname="rounded-full w-8 h-8 "
                  src="../assets/insta.png"
                  alt="instagram"
                />
              </div>
            </li>
          </ul>
        </div>
        <div class="flex flex-col items-center justify-center bg-white p-4  rounded-lg shadow-2xl shadow-black">
          <div class="inline-flex shadow-lg border border-gray-200 rounded-full overflow-hidden h-40 w-40">
            <img src="./assets/tonikroos.jpg" alt="" class="h-full w-full" />
          </div>

          <h2 class="mt-4 font-bold text-xl">Toni Kroos</h2>
          <h6 class="mt-2 text-sm font-medium">Product Developer</h6>

          <ul class="flex flex-row mt-4 space-x-2">
            <li>
              <div
                href=""
                class="flex items-center   justify-center h-8 w-8  text-gray-800 border-gray-800"
              >
                <img
                  classname="rounded-full w-8 h-8 "
                  src="../assets/facebook.png"
                  alt="instagram"
                />
              </div>
            </li>
            <li>
              <div
                href=""
                class="flex items-center   justify-center h-8 w-8  text-gray-800 border-gray-800"
              >
                <img
                  classname="rounded-full w-8 h-8 "
                  src="../assets/twitter.png"
                  alt="instagram"
                />
              </div>
            </li>
            <li>
              <div
                href=""
                class="flex items-center   justify-center h-8 w-8  text-gray-800 border-gray-800"
              >
                <img
                  classname="rounded-full w-8 h-8 "
                  src="../assets/insta.png"
                  alt="instagram"
                />
              </div>
            </li>
          </ul>
        </div>
        <div class="flex flex-col items-center justify-center bg-white p-4 shadow-2xl shadow-black rounded-lg">
          <div class="inline-flex shadow-lg border border-gray-200 rounded-full overflow-hidden h-40 w-40">
            <img src="./assets/ikercasillas.jpg" alt="" class="h-full w-full" />
          </div>

          <h2 class="mt-4 font-bold text-xl">Iker Casillas</h2>
          <h6 class="mt-2 text-sm font-medium">Marketing Strategy</h6>

          <ul class="flex flex-row mt-4 space-x-2">
            <li>
              <div
                href=""
                class="flex items-center   justify-center h-8 w-8  text-gray-800 border-gray-800"
              >
                <img
                  classname="rounded-full w-8 h-8 "
                  src="../assets/facebook.png"
                  alt="instagram"
                />
              </div>
            </li>
            <li>
              <div
                href=""
                class="flex items-center   justify-center h-8 w-8  text-gray-800 border-gray-800"
              >
                <img
                  classname="rounded-full w-8 h-8 "
                  src="../assets/twitter.png"
                  alt="instagram"
                />
              </div>
            </li>
            <li>
              <div
                href=""
                class="flex items-center   justify-center h-8 w-8 text-gray-800 border-gray-800"
              >
                <img
                  classname="rounded-full w-8 h-8 "
                  src="../assets/insta.png"
                  alt="instagram"
                />
              </div>
            </li>
          </ul>
        </div>
        <div class="flex flex-col items-center justify-center bg-white p-4 shadow-2xl shadow-black rounded-lg">
          <div class="inline-flex shadow-lg border border-gray-200 rounded-full overflow-hidden h-40 w-40">
            <img src="./assets/james.jpg" alt="" class="h-full w-full" />
          </div>

          <h2 class="mt-4 font-bold text-xl">James</h2>
          <h6 class="mt-2 text-sm font-medium">Product designer</h6>

          <ul class="flex flex-row mt-4 space-x-2">
            <li>
              <div
                href=""
                class="flex items-center   justify-center h-8 w-8  text-gray-800 border-gray-800"
              >
                <img
                  classname="rounded-full w-8 h-8 "
                  src="../assets/facebook.png"
                  alt="instagram"
                />
              </div>
            </li>
            <li>
              <div
                href=""
                class="flex items-center   justify-center h-8 w-8  text-gray-800 border-gray-800"
              >
                <img
                  classname="rounded-full w-8 h-8 "
                  src="../assets/twitter.png"
                  alt="instagram"
                />
              </div>
            </li>
            <li>
              <div
                href=""
                class="flex items-center   justify-center h-8 w-8  text-gray-800 border-gray-800"
              >
                <img
                  classname="rounded-full w-8 h-8 "
                  src="../assets/insta.png"
                  alt="instagram"
                />
              </div>
            </li>
          </ul>
        </div>
        <div class="flex flex-col items-center justify-center bg-white p-4 shadow-2xl shadow-black  rounded-lg">
          <div class="inline-flex shadow-lg border border-gray-200 rounded-full overflow-hidden h-40 w-40">
            <img src="./assets/christiano.jpg" alt="" class="h-full w-full" />
          </div>

          <h2 class="mt-4 font-bold text-xl">Cristiano Ronaldo</h2>
          <h6 class="mt-2 text-sm font-medium">Financial operations</h6>

          <ul class="flex flex-row mt-4 space-x-2">
            <li>
              <div
                href=""
                class="flex items-center   justify-center h-8 w-8  text-gray-800 border-gray-800"
              >
                <img
                  classname="rounded-full w-8 h-8 "
                  src="../assets/facebook.png"
                  alt="instagram"
                />
              </div>
            </li>
            <li>
              <div
                href=""
                class="flex items-center   justify-center h-8 w-8  text-gray-800 border-gray-800"
              >
                <img
                  classname="rounded-full w-8 h-8 "
                  src="../assets/twitter.png"
                  alt="instagram"
                />
              </div>
            </li>
            <li>
              <div
                href=""
                class="flex items-center   justify-center h-8 w-8  text-gray-800 border-gray-800"
              >
                <img
                  classname="rounded-full w-8 h-8 "
                  src="../assets/insta.png"
                  alt="instagram"
                />
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div className="text-3xl font-productsans flex items-center justify-center mt-10 ">
        And YOU !&#41;
      </div>
    </div>
  );
}

export default Team